import { createContext } from 'react';

import type { StoreApi } from 'zustand';

import type { MergePurgeStore } from './types/merge-purge-store.type';

export const MergePurgeContext = createContext<StoreApi<MergePurgeStore> | undefined>(undefined);
